import { Box, styled } from '@withjoy/joykit';
import { animationTransitionExt } from '@shared/utils/animationTransition';
import { ResponsiveValue } from '@withjoy/joykit/styled-system';
import { Colors, pxToRem } from '@withjoy/joykit/theme';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const StyledSliderContainer = styled(Box)``;
const sliderContainerStyles = (dotsColor?: ResponsiveValue<keyof Colors | (string & {})>): CSSObject => ({
  ['.slick-dots']: {
    bottom: {
      _: pxToRem(20),
      sm: pxToRem(28)
    }
  },
  ['.slick-dots li']: {
    margin: 0,
    ['button:before']: {
      fontSize: pxToRem(10),
      color: dotsColor ? dotsColor : 'white',
      transition: animationTransitionExt({ property: 'color' }),
      opacity: 0.5
    },
    // Overrides css from third party css
    ['button:focus:before']: {
      opacity: 0.5
    },
    ['button:hover:before']: {
      opacity: 0.5
    },
    ['&.slick-active button:before']: {
      color: dotsColor ? dotsColor : 'white',
      transition: animationTransitionExt({ property: 'color' }),
      opacity: 1
    }
  }
});

export const styles = {
  sliderContainer: sliderContainerStyles
};
